import * as React from 'react';
import { useEffect, useState } from 'react';
import { FooterContainer } from '../Footer';
import { VacancyLayout } from './components/VacancyLayout/VacancyLayout';
import { VacancyInfoContainer } from '../VacancyInfoContainer/VacancyInfoContainer';
import { VacancyHeaderContainer } from '../VacancyHeader/VacancyHeaderContainer';
import { ApplyOrRecommendContainer } from '../ApplyModalContainer';
import { EAction } from '../../common/repositories/job-vacancies-backend/entities/button/ButtonSchema';
import { useDispatch } from 'react-redux';
import { resetForm } from '../../actions/form';
import { TThunkDispatch } from '../../types/redux';
import { sendOpenApplyFormEvent, sendOpenRecommendFormEvent } from '../../utils/analytics/events/openForm';
import { connectState } from '../../actions/state';
import { sendOpenVacancyPageEvent } from '../../utils/analytics/events/openVacancyPage';

export const VacancyContainer: React.FC = () => {
  const [isApplyWindowOpen, setIsApplyWindowOpen] = useState<boolean>(false);
  const [isRecommendWindowOpen, setIsRecommendWindowOpen] = useState<boolean>(false);
  const dispatch = useDispatch<TThunkDispatch>();

  useEffect(() => {
    dispatch(connectState(sendOpenVacancyPageEvent));
  }, [dispatch]);

  const handleOpenModals = (action: EAction) => {
    switch (action) {
      case EAction.Apply:
        setIsApplyWindowOpen(true);
        dispatch(connectState(sendOpenApplyFormEvent));
        break;
      case EAction.Recommend:
        setIsRecommendWindowOpen(true);
        dispatch(connectState(sendOpenRecommendFormEvent));
    }
  };

  const handleCloseModals = () => {
    setIsApplyWindowOpen(false);
    setIsRecommendWindowOpen(false);
    // Сначала выжидаем анимацию закрытия модалки
    setTimeout(() => dispatch(resetForm()), 300);
  };

  return (
    <>
      <VacancyLayout
        header={<VacancyHeaderContainer />}
        vacancy={<VacancyInfoContainer onClickHandler={handleOpenModals} />}
        footer={<FooterContainer />}
      />
      <ApplyOrRecommendContainer
        isApplyWindowOpen={isApplyWindowOpen}
        isRecommendWindowOpen={isRecommendWindowOpen}
        onClose={handleCloseModals}
      />
    </>
  );
};

VacancyContainer.displayName = 'VacancyContainer';
